import {Col, Collapse, Row, Spin} from "antd";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {courierTypes} from "../../constants/constants";
import {useFetch} from "../../hooks/useFetch";
import {useStore} from "../../hooks/useStore";
import {CityFilter} from "../_defaultComponents/FilterComponents";
import DataBox from "./DataBox";
import {OptionsRow, SelectField, Center} from "./styles";

const ShiftCompliance = () => {
    const stores = useStore();

    const {t} = useTranslation(["shiftCompliance"]);
    const allCity = t("filters.all", {ns: "common"});
    const filters = stores.meStore.orderPage?.filters;
    const {Panel} = Collapse;

    const [cities, setCities] = useState();
    const [total, setTotal] = useState();
    const [selectedCity, setSelectedCity] = useState(allCity);
    const [selectedUpperGroup, setSelectedUpperGroup] = useState(allCity);
    const [courierType, setCourierType] = useState("all");
    const [filterCity, setFilterCity] = useState(stores.meStore.map.filters.city);
    const [filterUpperGroup, setFilterUpperGroup] = useState(filters.upperGroup);
    const [activeKeys, setActiveKeys] = useState([]);

    const [recall, setRecall] = useState(true);
    const recallRef = useRef(recall);
    recallRef.current = recall;

    const [loading, data, ,] = useFetch({
        defaultDataValue: null,
        initialCall: true,
        fetchFn: stores.shiftStore.getShiftCompliance.bind(null, {
            city: filterCity,
            upperGroup: filterUpperGroup,
            courierType: courierType
        }),
        dependencies: [recall, filterCity, filterUpperGroup, courierType]
    });
    const [, upperGroupsByCompanyAndCity, ,] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.regionStore.getUpperGroupsByCompanyIdAndCity.bind(null, {
            companyId: filters.companies.join("."),
            city: stores.meStore.map.filters.city
        }),
        dependencies: [stores.meStore.map.filters.city, filters.companies],
        initialCall: true
    });

    useEffect(() => {
        setSelectedUpperGroup(allCity);
        setTotal(data?.total);
        if (selectedCity === allCity) {
            setCities(data?.result);
            return;
        }
        setCities(data?.result.filter(city => city?.name === selectedCity));
    }, [data]);

    useEffect(() => {
        setTimeout(() => {
            setRecall(!recallRef.current);
        }, 60000);
    }, [recall]);

    const renderData = (branchData, isFirst = false) => {
        return (
            branchData &&
            branchData.map((branch, i) => (
                <Panel
                    header={
                        <DataBox
                            data={branch}
                            onClick={e => {
                                !branch?.items && e.stopPropagation();
                            }}
                        />
                    }
                    className={isFirst ? "custom" : ""}
                    key={`${branch.name}-${i}`}
                    showArrow={!!branch?.items}
                >
                    {branch?.items?.length > 0 && (
                        <Collapse
                            onChange={prev => setActiveKeys([...prev, `${branch.name}-${i}`])}
                            defaultActiveKey={activeKeys}
                        >
                            {renderData(branch.items)}
                        </Collapse>
                    )}
                    {!branch?.items && <></>}
                </Panel>
            ))
        );
    };
    const renderTotal = branchData => {
        return (
            <Panel
                style={{
                    backgroundColor: "#E8E8E8",
                    fontWeight: "bold"
                }}
                showArrow={false}
                header={
                    <DataBox
                        data={branchData}
                        name={t("generalStatistic", {ns: "shiftCompliance"})}
                    />
                }
            />
        );
    };

    return (
        <div>
            <OptionsRow type="flex" justify="space-between" data-testid="ShiftCompliance">
                <Col lg={24} xl={18} xxl={20}>
                    <Row type="flex" gutter={[20, 20]}>
                        {
                            <Col xs={20} sm={16} md={12} lg={8} xl={4}>
                                <CityFilter
                                    value={filterCity}
                                    onChange={value => {
                                        setFilterCity(value);
                                        setFilterUpperGroup("all");
                                        setActiveKeys([]);
                                        stores.meStore.map.filters.city = value;
                                    }}
                                />
                            </Col>
                        }
                        {
                            <Col xs={20} sm={16} md={12} lg={8} xl={4}>
                                <h5>{t("fields.upperGroup", {ns: "common"})}</h5>
                                <SelectField
                                    value={filterCity === "all" ? "" : filterUpperGroup}
                                    onChange={value => {
                                        setFilterUpperGroup(value);
                                        setActiveKeys([]);
                                        stores.meStore.orderPage.filters.upperGroup = value;
                                        stores.meStore.orderPage.filters.regionGroups = [];
                                    }}
                                    disabled={filterCity === "all"}
                                    notFoundContent={t("filters.dataNotFound", {ns: "common"})}
                                    placeholder={t("filters.addFilter", {ns: "common"})}
                                    optionFilterProp="children"
                                    data-testid="upperGroupSelect"
                                    filterOption={(input, option) =>
                                        option.children
                                            .toString()
                                            .toLocaleLowerCase("tr-TR")
                                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.children
                                            .toString()
                                            .toLocaleLowerCase("tr-TR")
                                            .localeCompare(
                                                optionB.children
                                                    .toString()
                                                    .toLocaleLowerCase("tr-TR")
                                            )
                                    }
                                >
                                    <SelectField.Option value="all">
                                        {t("filters.all", {ns: "common"})}
                                    </SelectField.Option>
                                    {upperGroupsByCompanyAndCity.map(upperGroup => (
                                        <SelectField.Option
                                            key={upperGroup.group}
                                            value={upperGroup.group}
                                            data-testid="upperGroupSelect_option"
                                        >
                                            {upperGroup.group}
                                        </SelectField.Option>
                                    ))}
                                </SelectField>
                            </Col>
                        }
                        {
                            <Col xs={20} sm={16} md={12} lg={8} xl={4}>
                                <h5>{t("fields.courierType", {ns: "common"})}</h5>
                                <SelectField
                                    data-testid="courierTypeSelect"
                                    value={courierType}
                                    placeholder={t("filters.addFilter", {ns: "common"})}
                                    onChange={value => setCourierType(value)}
                                >
                                    <SelectField.Option
                                        data-testid="courierTypeSelect_option"
                                        key={"courierType-all"}
                                        value={"all"}
                                    >
                                        {t("filters.all", {ns: "common"})}
                                    </SelectField.Option>
                                    {courierTypes.map(type => (
                                        <SelectField.Option
                                            key={type.value}
                                            value={type.value}
                                            data-testid="courierTypeSelect_option"
                                        >
                                            <span>
                                                {t(type.translation_key, {ns: "courierTypes"})}
                                            </span>
                                        </SelectField.Option>
                                    ))}
                                </SelectField>
                            </Col>
                        }
                    </Row>
                </Col>
            </OptionsRow>
            <Col lg={24} xl={18} xxl={10}>
                {activeKeys.length === 0 && loading ? (
                    <Center>
                        <Spin size="large" spinning={loading}></Spin>
                    </Center>
                ) : (
                    <>
                        <Collapse showArrow={false} defaultActiveKey={activeKeys}>
                            {renderTotal(total, true)}
                        </Collapse>
                        <Collapse defaultActiveKey={activeKeys}>
                            {renderData(cities, true)}
                        </Collapse>
                    </>
                )}
            </Col>
        </div>
    );
};

export default ShiftCompliance;
